<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Protocolo Planeado Para el Uso de Alineadores</mat-card-title>
      <mat-card-content class="row w-100 w-sm-75 mt-2">
          <div class="w-100 justify-content-start">
            <mat-radio-group aria-label="Seleciona una opción" formControlName="protocolDays" class="mt-5 mt-sm-0 d-flex flex-wrap gap-4">
              <div class="row gx-4 gy-2" *ngFor="let item of protocolDaysOptions">
                <mat-radio-button [value]="item"
                  [checked]="item == getControl(stepFormGroup,'protocolDays')" class="py-6"
                ><p style="white-space:normal;">Utilizar un alineador cada {{item}} días</p></mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
      </mat-card-content>
    </mat-card>



    <mat-card class="card-general">
      <mat-card-title>Cantidad de Alineadores por Arcada</mat-card-title>
      <mat-card-content class="w-100 w-sm-75 mt-2">
        <mat-radio-group aria-label="Seleciona una opción" formControlName="coordinateNumberAlignersType" class="d-flex flex-wrap flex-column gap-4">
          <div class="row" *ngFor="let item of coordinateNumberAlignersTypeOptions">
            <mat-radio-button [value]="item.value"
            [checked]="item.value == getControl(stepFormGroup,'coordinateNumberAlignersType')" class="col-12 col-sm-4"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            <div class="col-12 col-sm-8 pb-5" [ngClass]="{'text-border-bottom': i != 2}">
              <p class="text-justify w-fit mx-auto" style="max-width: 350px;">
                {{item.description}}
              </p>
            </div>
          </div>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
    <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="protocolUseAlignersComments" formControlName="protocolUseAlignersComments" style="height: 120px;"></textarea>
    </form>
    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <div class="text-center">
        <mat-checkbox style="width: fit-content;" class="col text-start" [(ngModel)]="confirmCheckbox" (change)="onCheckboxChange($event.checked)"><span style="white-space:normal;" >Confirmo que la información anteriormente detallada es correcta y acepto que mi propuesta de setup se hará con base a la información previamente detallada.</span></mat-checkbox>
      </div>
    </div>
    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <ng-container class="mx-auto" *ngIf="loading" style="width: 40px;">
        <app-loading></app-loading>
      </ng-container>
      <button mat-button matStepperNext data-testid="nextStep9" [hidden]="!getShowSaveButton" class="button secondary-button" (click)="updateStepPrescription()">Guardar <mat-icon>save</mat-icon></button>
    </div>

</div>

<app-dialog #generatingPDFDialog [enableCloseDialogButton]="false" [preventCloseFromBackDrop]="true" [enableConfirmButton]="false" height="90%" width="60%">
  <div>
    <div class="w-100 w-sm-50 mx-auto d-flex flex-column gap-5 p-4 justify-content-center align-items-center">
      <h2 class="col text-center">Generando el documento de Prescripción</h2>
      <app-loading size="64px"></app-loading>
      <p>Se estan validando todos los datos establecidos en la prescripción para generar el documento pdf, espera un momento...</p>
    </div>
  </div>
</app-dialog>


<app-dialog #generatingPDFErrorDialog [enableCloseDialogButton]="false" [preventCloseFromBackDrop]="true" [enableConfirmButton]="true" confirmButtonText="Aceptar" height="90%" width="60%">
  <div>
    <div class="w-100 w-sm-50 mx-auto d-flex flex-column gap-5 p-4 justify-content-center align-items-center">
      <h2 class="col text-center">Error</h2>
      <p>No se generó el archivo de prescripción, favor de intentarlo de nuevo. En caso de persistir el error, contacte a su administrador.</p>
    </div>
  </div>
</app-dialog>